import axios from 'axios'
import errorHandler from './error-handler'

export default {
  async initiateWallet () {
    return axios.post('/api/stacks/attach').then(r => r.data).catch(errorHandler)
  },
  async verifyAttachment (data) {
    return axios.post('/api/stacks/verify-attachment', data).then(r => r).catch(errorHandler)
  },
  async initialWalletLogin (data) {
    return axios.post('/api/stacks/login', data).then(r => r.data).catch(errorHandler)
  },
  async verifyLoginSignature (data) {
    return axios.post('/api/stacks/verify-login', data).then(r => r).catch(errorHandler)
  },
  async confirmWalletByEmail (data) {
    return axios.post('/api/stacks/confirm-with-email', data).then(r => r.data).catch(errorHandler)
  },
  async disconnectWallet () {
    return axios.post('/api/stacks/detach').then(r => r.data).catch(errorHandler)
  },
  async getWalletStatus () {
    return axios.get('/api/stacks/wallet').then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/wallet.js